import { render, staticRenderFns } from "./RequerimientoActions.vue?vue&type=template&id=303fe5e3&scoped=true&"
import script from "./RequerimientoActions.vue?vue&type=script&lang=js&"
export * from "./RequerimientoActions.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoActions.vue?vue&type=style&index=0&id=303fe5e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fe5e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardActions,
  VIcon,
  VTooltip,
})
